import { createAction } from 'redux-act';

export const setFacilitatorsConsentAgreement = createAction();
export const setFacilitatorsConsentAgreementSuccess = createAction();
export const setFacilitatorsConsentAgreementError = createAction();
